// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OMuf_uAFXlbkaWorhSAO {
  padding: 16px;
  margin-bottom: 24px;
  background: #F4F4F4;
  border-radius: 8px;
}
.dark-mode .OMuf_uAFXlbkaWorhSAO {
  background: #272B30;
}

.isT8Rs8BUsri_acLIuz_ {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.wAuI1lX2_HzuEUnFA8_N {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: -0.02em;
  margin-right: auto;
}
@media only screen and (max-width: 767px) {
  .wAuI1lX2_HzuEUnFA8_N {
    font-size: 18px;
  }
}

.Z_NETaqR19xVcMvVeEfT {
  display: none;
}

.sXc8_Usoww4FO93rKcQv {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.seawk4BDj4MQrwuNMuxp {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  padding: 12px 16px;
  border-radius: 8px;
  border-left: 4px solid transparent;
  background: #FCFCFC;
}
.dark-mode .seawk4BDj4MQrwuNMuxp {
  background: #1A1D1F;
}

.seawk4BDj4MQrwuNMuxp span {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #6F767E;
}
.seawk4BDj4MQrwuNMuxp strong {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: -0.02em;
}
@media only screen and (max-width: 767px) {
  .seawk4BDj4MQrwuNMuxp strong {
    font-size: 18px;
  }
}
.seawk4BDj4MQrwuNMuxp.NajLiELs5MWd_Py55X5f {
  border-color: #2A85FF;
  background: rgba(42, 133, 255, 0.1);
}
.seawk4BDj4MQrwuNMuxp.NajLiELs5MWd_Py55X5f strong {
  color: #2A85FF;
}
.seawk4BDj4MQrwuNMuxp.B7S5pRlolN580j2WX8yY {
  border-color: #8E59FF;
  background: rgba(142, 89, 255, 0.1);
}
.seawk4BDj4MQrwuNMuxp.B7S5pRlolN580j2WX8yY strong {
  color: #8E59FF;
}
.seawk4BDj4MQrwuNMuxp.T5rul7Dxsg5Ig6ljHTLv {
  border-color: #83BF6E;
  background: rgba(131, 191, 110, 0.12);
}
.seawk4BDj4MQrwuNMuxp.T5rul7Dxsg5Ig6ljHTLv strong {
  color: #83BF6E;
}
.seawk4BDj4MQrwuNMuxp.y7gCuf2BFFXmMOnwLXjg {
  border-color: #FF6A55;
  background: rgba(255, 106, 85, 0.1);
}
.seawk4BDj4MQrwuNMuxp.y7gCuf2BFFXmMOnwLXjg strong {
  color: #FF6A55;
}

.Ib8w7iZl6neXR9ZiPVRS {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  margin-top: 12px;
  color: #6F767E;
}

.alzOxujZr5VSCd1sr30u {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
}

.AUMwQcyPVqIXQDxKrBLS {
  color: #e70000;
}`, "",{"version":3,"sources":["webpack://./src/pages/ticket_delivery/details/QrCodes/QrCodes.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBCqCC;EDpCD,kBAAA;AADJ;ACuLa;EDpLL,mBCsCH;ADtCL;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AACA;ECyCI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ED1CA,kBAAA;AAKJ;ACPI;EDAJ;IC8CQ,eAAA;EDnCN;AACF;;AARA;EACI,aAAA;AAWJ;;AATA;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAYJ;;AAVA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBCKC;ADQL;AC2Ia;EDtJL,mBCSH;ADKL;;AAbI;ECuEA,eAAA;EACA,gBAAA;EACA,yBAAA;EDvEI,cCGH;ADeL;AAjBI;ECeA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ADKJ;ACjDI;ED0BA;ICoBI,eAAA;EDON;AACF;AA1BI;EACI,qBCfH;EDgBG,mCAAA;AA4BR;AA3BQ;EACI,cClBP;AD+CL;AA5BI;EACI,qBCjBH;EDkBG,mCAAA;AA8BR;AA7BQ;EACI,cCpBP;ADmDL;AA9BI;EACI,qBCxBH;EDyBG,qCAAA;AAgCR;AA/BQ;EACI,cC3BP;AD4DL;AAhCI;EACI,qBC5BH;ED6BG,mCAAA;AAkCR;AAjCQ;EACI,cC/BP;ADkEL;;AAjCA;EC6CI,eAAA;EACA,gBAAA;EACA,yBAAA;ED7CA,gBAAA;EACA,cCxBC;AD8DL;;AApCA;ECwCI,eAAA;EACA,gBAAA;EACA,yBAAA;EDxCA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAyCJ;;AAvCA;EACI,cAAA;AA0CJ","sourcesContent":["@import ../../../../styles/helpers\n\n.wrapper\n    padding: 16px\n    margin-bottom: 24px\n    background: $n2\n    border-radius: 8px\n    +dark\n        background: $n6\n\n.head\n    display: flex\n    align-items: center\n    gap: 12px\n    margin-bottom: 16px\n\n.title\n    +title1-s\n    margin-right: auto\n\n.input\n    display: none\n\n.stats\n    display: flex\n    flex-wrap: wrap\n    gap: 12px\n\n.stat\n    display: flex\n    flex-direction: column\n    gap: 4px\n    min-width: 140px\n    padding: 12px 16px\n    border-radius: 8px\n    border-left: 4px solid transparent\n    background: $n1\n    +dark\n        background: $n7\n    span\n        +caption1\n        color: $n4\n    strong\n        +title1-s\n    &.total\n        border-color: $p1\n        background: rgba($p1, .1)\n        strong\n            color: $p1\n    &.assigned\n        border-color: $p4\n        background: rgba($p4, .1)\n        strong\n            color: $p4\n    &.available\n        border-color: $p2\n        background: rgba($p2, .12)\n        strong\n            color: $p2\n    &.empty\n        border-color: $p3\n        background: rgba($p3, .1)\n        strong\n            color: $p3\n\n.hint\n    +caption1\n    margin-top: 12px\n    color: $n4\n\n.result\n    +caption1\n    display: flex\n    flex-direction: column\n    gap: 4px\n    margin-top: 12px\n\n.error\n    color: #e70000\n","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `OMuf_uAFXlbkaWorhSAO`,
	"head": `isT8Rs8BUsri_acLIuz_`,
	"title": `wAuI1lX2_HzuEUnFA8_N`,
	"input": `Z_NETaqR19xVcMvVeEfT`,
	"stats": `sXc8_Usoww4FO93rKcQv`,
	"stat": `seawk4BDj4MQrwuNMuxp`,
	"total": `NajLiELs5MWd_Py55X5f`,
	"assigned": `B7S5pRlolN580j2WX8yY`,
	"available": `T5rul7Dxsg5Ig6ljHTLv`,
	"empty": `y7gCuf2BFFXmMOnwLXjg`,
	"hint": `Ib8w7iZl6neXR9ZiPVRS`,
	"result": `alzOxujZr5VSCd1sr30u`,
	"error": `AUMwQcyPVqIXQDxKrBLS`
};
export default ___CSS_LOADER_EXPORT___;
